/* Fallback cover partagé : dégradé déterministe selon l'id.
   Utilisé par les listes (dashboard, sorties, analytics) et le modal release
   (aperçu, création, édition) pour un rendu strictement identique partout. */
const PALETTES = [
  'linear-gradient(135deg,#d2a49b,#4b1c27)',
  'linear-gradient(135deg,#153b4b,#0b1722)',
  'linear-gradient(135deg,#c98d42,#542718)',
];

export const coverGradientFor = (id = '') => {
  let h = 0;
  for (const c of String(id)) h = (h * 31 + c.charCodeAt(0)) % 997;
  return PALETTES[h % PALETTES.length];
};
